import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { InfoRegraFormula } from 'src/app/models/info-regra-formula';
import { InfoRegra } from 'src/app/models/InfoRegra';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-info-regras-modal',
  templateUrl: './info-regras-modal.component.html',
  styleUrls: ['./info-regras-modal.component.scss']
})
export class InfoRegrasModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  infos: InfoRegraFormula;

  constructor(public dialogRef: MatDialogRef<InfoRegrasModalComponent>, private pedidoService: PedidoService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private utilitarioService: UtilitarioService,
    private globalService: GlobalService) { }

  ngOnInit(): void {
    this.buscarInfos();
  }

  voltar() {
    this.dialogRef.close();
  }

  buscarInfos() {
    this.carregandoService.mostra('buscarInfos');
    this.pedidoService.consultarInfoRegras().subscribe(
      (retorno) => {

        this.infos = retorno;
        this.carregandoService.esconde('buscarInfos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarInfos');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
